import React from 'react';

const LibraryOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill='currentColor'
      viewBox='0 0 24 24'
      transform=''
      id='injected-svg'
      {...props}
    >
      <path d='m18.29,9.29l-3.29,3.29-4.29-4.29c-.39-.39-1.02-.39-1.41,0l-7,7,1.41,1.41,6.29-6.29,4.29,4.29c.39.39,1.02.39,1.41,0l4-4,2.29,2.29v-6h-6l2.29,2.29Z' />
    </svg>
  );
};

export default LibraryOutlineIcon;
